export default __webpack_public_path__ + "static/media/checkbox-checked.f656b12f.svg";